export const SET_SELECTED_ADDRESS = 'SET_SELECTED_ADDRESS';

export const SET_PARAMS = 'SET_PARAMS'
export const SET_PROPERTY_MATCHES = 'SET_PROPERTY_MATCHES'